/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SwitchField from "components/SwitchField";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "",
    code: "",
    asset: "TÀI SẢN",
    assetBold: true,
    assetCenter: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "110",
    code: "I",
    asset: "I. Tiền và các khoản tương đương tiền",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "120",
    code: "I",
    asset: "II. Đầu tư tài chính",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "121",
    code: "I",
    asset: "1. Chứng khoán kinh doanh",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "122",
    code: "I",
    asset: "2. Đầu tư nắm giữ đến ngày đáo hạn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "123",
    code: "I",
    asset: "3. Đầu tư góp vốn vào đơn vị khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "124",
    code: "I",
    asset: "4. Dự phòng tổn thất đầu tư tài chính (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "130",
    code: "I",
    asset: "III. Các khoản phải thu",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "131",
    code: "I",
    asset: "1. Phải thu của khách hàng",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "132",
    code: "I",
    asset: "2. Trả trước cho người bán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "133",
    code: "I",
    asset: "3. Vốn kinh doanh ở đơn vị trực thuộc",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "134",
    code: "I",
    asset: "4. Phải thu khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "135",
    code: "I",
    asset: "5. Tài sản thiếu chờ xử lý",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "136",
    code: "I",
    asset: "6. Dự phòng phải thu khó đòi (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "137",
    code: "I",
    asset: "7. Phải thu của hoạt động tín dụng nội bộ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "140",
    code: "I",
    asset: "IV. Hàng tồn kho",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "141",
    code: "I",
    asset: "1. Hàng tồn kho",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "142",
    code: "I",
    asset: "2. Dự phòng giảm giá hàng tồn kho",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "150",
    code: "I",
    asset: "V. Tài sản cố định",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 19,
    stt: "151",
    code: "I",
    asset: "- Nguyên giá",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "152",
    code: "I",
    asset: "- Giá trị hao mòn lũy kế (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "160",
    code: "I",
    asset: "Bất động sản đầu tư",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "161",
    code: "I",
    asset: "- Nguyên giá",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "162",
    code: "I",
    asset: "- Giá trị hao mòn lũy kế (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "170",
    code: "I",
    asset: "VII. XDCB dở dang",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "180",
    code: "I",
    asset: "VIII. Tài sản khác",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "181",
    code: "I",
    asset: "1. Thuế GTGT được khấu trừ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "182",
    code: "I",
    asset: "2. Tài sản khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 28,
    stt: "200",
    code: "I",
    asset: "TỔNG CỘNG TÀI SẢN (200=110+120+130+140+150+160+170+180)",
    assetCenter: true,
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "",
    code: "",
    asset: "NGUỒN VỐN",
    assetBold: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 30,
    stt: "300",
    code: "I",
    asset: "I. Nợ phải trả",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 31,
    stt: "311",
    code: "I",
    asset: "1. Phải trả người bán",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 32,
    stt: "312",
    code: "I",
    asset: "2. Người mua trả tiền trước",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 33,
    stt: "313",
    code: "I",
    asset: "3. Thuế và các khoản phải nộp Nhà nước",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 34,
    stt: "314",
    code: "I",
    asset: "4. Phải trả người lao động",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 35,
    stt: "315",
    code: "I",
    asset: "5. Phải trả khác",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 36,
    stt: "316",
    code: "I",
    asset: "6. Vay và nợ thuê tài chính",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 37,
    stt: "317",
    code: "I",
    asset: "7. Phải trả nội bộ về vốn kinh doanh",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 38,
    stt: "318",
    code: "I",
    asset: "8. Dự phòng phải trả",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 39,
    stt: "319",
    code: "I",
    asset: "9. Quỹ khen thưởng, phúc lợi",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 40,
    stt: "320",
    code: "I",
    asset: "10. Quỹ phát triển khoa học và công nghệ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 41,
    stt: "370",
    code: "I",
    asset: "11. Phải trả của hoạt động tín dụng nội bộ",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 42,
    stt: "380",
    code: "I",
    asset: "12. Khoản trợ cấp, hỗ trợ của Nhà nước phải hoàn",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 43,
    stt: "390",
    code: "I",
    asset: "13. Quỹ dự phòng rủi ro tín dụng",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 44,
    stt: "400",
    code: "I",
    asset: "II. Vốn chủ sở hữu",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 45,
    stt: "411",
    code: "I",
    asset: "1. Vốn góp của chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 46,
    stt: "412",
    code: "I",
    asset: "2. Thặng dư vốn cổ phần",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 47,
    stt: "413",
    code: "I",
    asset: "3. Vốn khác của chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 48,
    stt: "414",
    code: "I",
    asset: "4. Cổ phiếu quỹ (*)",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 49,
    stt: "415",
    code: "I",
    asset: "5. Chênh lệch tỷ giá hối đoái",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 50,
    stt: "416",
    code: "I",
    asset: "6. Các quỹ thuộc vốn chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 51,
    stt: "417",
    code: "I",
    asset: "7. Lợi nhuận sau thuế chưa phân phối",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 52,
    stt: "440",
    code: "I",
    asset: "8. Nguồn vốn nhận trợ cấp, hỗ trợ không hoàn lại",
    assetBold: false,
    sttBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 53,
    stt: "500",
    code: "I",
    asset: "TỔNG CỘNG NGUỒN VỐN (500=300+400)",
    assetBold: true,
    sttBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Mã số</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Số cuối năm</Th>
              <Th style={{ textAlign: "center" }}>Số đầu năm</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>1</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>2</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>3</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>4</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold" }}>5</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  {rows.valueCenter && rows.valueCenter === true ? (
                    <>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.now}
                      </Td>
                      <Td
                        style={{
                          textAlign: "center",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        {rows.value.before}
                      </Td>
                    </>
                  ) : (
                    <>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="now"
                          readOnly={rows.readOnly}
                          value={rows.value.now}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                      <Td
                        colSpan={1}
                        style={{
                          textAlign: "right",
                          background: rows.readOnly === true ? "#ddeff3" : "transparent",
                          fontWeight: rows.readOnly === true ? "bold" : 400,
                        }}
                      >
                        <InputTable
                          id={rows.id}
                          name="before"
                          readOnly={rows.readOnly}
                          value={rows.value.before}
                          onChange={handleChange}
                          fontWeight={rows.valueBold}
                        />
                      </Td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
